import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=5e30b48a&"
import script from "./product_list.vue?vue&type=script&lang=js&"
export * from "./product_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e30b48a')) {
      api.createRecord('5e30b48a', component.options)
    } else {
      api.reload('5e30b48a', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=5e30b48a&", function () {
      api.rerender('5e30b48a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/banquet_present/form/product_list.vue"
export default component.exports